import './ActionsPanel.css';
import React from 'react';
import Loader from './loader';
const ProgressApplication = _ref => {
  let {
    rtl,
    actions,
    buttonState
  } = _ref;
  const DEFAULT_BUTTON_STATE = {
    inactive: false,
    loading: false,
    label: 'button'
  };
  const {
    continue: continueState = DEFAULT_BUTTON_STATE,
    save: saveState = DEFAULT_BUTTON_STATE,
    back: backState = DEFAULT_BUTTON_STATE
  } = buttonState || {};
  const {
    backAction = () => {},
    saveAction = () => {},
    contionueAction = () => {}
  } = actions || {};
  const continueEvent = e => {
    e.preventDefault();
    if (!continueState.loading && !continueState.inactive) contionueAction();
  };
  const backEvent = e => {
    e.preventDefault();
    if (!backState.loading && !backState.inactive) backAction();
  };
  const saveEvent = e => {
    e.preventDefault();
    if (!saveState.loading && !saveState.inactive) saveAction();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} `
  }, /*#__PURE__*/React.createElement("div", {
    className: " module-group module-group--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel__wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: `btn btn-secondary ${backState.inactive ? 'disabled' : ''} d-none  d-sm-block  `,
    onClick: backEvent
  }, backState.label), /*#__PURE__*/React.createElement("div", {
    className: "button-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: " "
  }, /*#__PURE__*/React.createElement("button", {
    className: `btn btn-secondary ${saveState.inactive ? 'disabled' : ''} ${saveState.loading ? 'loading' : ''}`,
    onClick: saveEvent
  }, saveState.loading ? /*#__PURE__*/React.createElement(Loader, {
    className: "loader"
  }) : '', /*#__PURE__*/React.createElement("span", null, saveState.label))), /*#__PURE__*/React.createElement("div", {
    className: " "
  }, /*#__PURE__*/React.createElement("button", {
    className: `btn btn-primary ${continueState.inactive ? 'disabled' : ''} ${continueState.loading ? 'loading' : ''}`,
    onClick: continueEvent
  }, continueState.loading ? /*#__PURE__*/React.createElement(Loader, null) : '', /*#__PURE__*/React.createElement("span", null, continueState.label)))))));
};
export default ProgressApplication;
const commonStyles = "c1f0nh9r";
const rtlStyles = "rsdgvx8";
const ltrStyles = "lfdbze1";